import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyCampaignRoutingModule as MyCampaignRoutingModule } from './my-campaign-routing.module';
import { MyCampaignPageComponent as MyCampaignPageComponent } from './pages/my-campaign-page.component';
import { SharedModule } from '@uw/shared/shared.module';
import { AngularMaterialModule } from '@uw/shared/material.module';
// import { ProgressBarModule } from 'angular-progress-bar';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        AngularMaterialModule,
        MyCampaignRoutingModule,
        // ProgressBarModule,
        TranslateModule,
        MyCampaignPageComponent
    ],
    exports: [MyCampaignPageComponent]
})
export class MyCampaignModule { }
